import { CompanySummary } from 'src/api/deinverband-api';
import { Company } from 'src/types/company';

export const mapCompanySummaryToCompany = (
  company: CompanySummary | undefined
): Company | undefined => {
  if (company?.id === undefined) return undefined;

  return {
    id: company.id,
    name: company.name || 'Unbekannt',
    address: {
      type: 'address',
      locality: company.city || 'Unbekannt',
      postalCode: company.postalCode || 'Unbekannt',
      streetAddress: company.street || undefined
    },
    contact: {
      phone: company.phone || undefined,
      fax: company.fax || undefined
    },
    memberships: []
  };
};
